import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-fetch";

const API_BASE = `${import.meta.env.BASE_URL.replace(/\/$/, "")}/api`;

export function useIsPlatformAdmin(): { isPlatformAdmin: boolean; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ["platform-admin", "access"],
    queryFn: async () => {
      const res = await apiFetch(`${API_BASE}/admin/platform-access`);
      if (!res.ok) return { ok: false };
      return res.json() as Promise<{ ok: boolean }>;
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    isPlatformAdmin: data?.ok === true,
    isLoading,
  };
}
